exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.showborderb .el-input__inner{\n  /* border: none; */\n}\n", ""]);

// exports
